import { Link } from 'react-router-dom';

export const Terms = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
    {/* Navigation */}
    <nav className="relative z-10 flex items-center justify-between p-6 lg:px-8">
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-[0_4px_12px_rgba(0,0,0,0.08)]">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <span className="ml-3 text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Finderz.AI
          </span>
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <Link 
          to="/login" 
          className="text-[#444] hover:text-[#171717] transition duration-300 font-medium"
        >
          Sign In
        </Link>
        <Link 
          to="/register" 
          className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2.5 rounded-xl hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transform hover:scale-105 transition duration-300 font-medium"
        >
          Get Started
        </Link>
      </div>
    </nav>

    {/* Terms Content */}
    <div className="max-w-4xl mx-auto px-6 py-12">
      <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] p-8 lg:p-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-[#171717] mb-4">
            Terms of Service
          </h1>
          <p className="text-lg text-[#555]">
            Last updated: January 1, 2025
          </p>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">1. Acceptance of Terms</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              By accessing and using Finderz.AI ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">2. Use License</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              Permission is granted to temporarily download one copy of Finderz.AI per device for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 text-[#444] mb-4">
              <li>modify or copy the materials</li>
              <li>use the materials for any commercial purpose or for any public display</li>
              <li>attempt to reverse engineer any software contained in Finderz.AI</li>
              <li>remove any copyright or other proprietary notations from the materials</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">3. User Accounts</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              When you create an account with us, you must provide information that is accurate, complete, and current at all times. You are responsible for safeguarding the password and for maintaining the confidentiality of your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">4. Data Protection</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              We take data protection seriously. All project data, personal information, and usage analytics are handled in accordance with our Privacy Policy and applicable data protection laws including GDPR and CCPA.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">5. Service Availability</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              While we strive for 99.9% uptime, we do not guarantee that the service will be available at all times. We reserve the right to modify or discontinue the service with reasonable notice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">6. Limitation of Liability</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              In no event shall Finderz.AI or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use Finderz.AI.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-[#171717] mb-4">7. Contact Information</h2>
            <p className="text-[#444] leading-relaxed mb-4">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-[#f5f5f5] p-4 rounded-lg">
              <p className="text-[#444]">
                <strong>Email:</strong> legal@finderz.ai<br />
                <strong>Address:</strong> 123 Tech Street, Silicon Valley, CA 94000
              </p>
            </div>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link 
            to="/" 
            className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl hover:shadow-[0_4px_12px_rgba(0,0,0,0.08)] transform hover:scale-105 transition duration-300 font-medium"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>

    {/* Footer */}
    <footer className="bg-white/80 backdrop-blur-sm mt-12">
      <div className="mx-auto max-w-7xl px-6 py-8 md:flex md:items-center md:justify-between lg:px-8">
        <div className="mt-4 md:order-1 md:mt-0">
          <p className="text-center text-xs leading-5 text-[#888]">
            &copy; 2025 Finderz.AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
); 